export type MerchantEnvironmentMode = 'sandbox' | 'live';

export const MERCHANT_ENVIRONMENT_MODE_STORAGE_KEY =
  'securepay_merchant_environment_mode';

export interface GoLiveResult {
  isLive?: boolean;
  requiresKyc?: boolean;
}

export interface GoLiveFeedback {
  title: string;
  message: string;
  isSuccess: boolean;
}

export function mapGoLiveFeedback(
  response:
    | Pick<
        { success?: boolean; statusCode?: string; message?: string | null },
        'success' | 'statusCode' | 'message'
      >
    | null
    | undefined,
): GoLiveFeedback {
  if (response?.success) {
    return {
      title: 'Go Live ON',
      message: response.message?.trim() || 'Your account is now in live mode.',
      isSuccess: true,
    };
  }

  const message =
    response?.message?.trim() ||
    'Failed to switch to live mode. Please try again.';

  switch (response?.statusCode) {
    case 'NotFound':
      return {
        title: 'Merchant not found',
        message,
        isSuccess: false,
      };
    case 'SYSTEM_ERROR':
      return {
        title: 'Something went wrong',
        message,
        isSuccess: false,
      };
    case 'BadRequest':
    case 'VALIDATION_ERROR':
    case 'Forbidden':
      return {
        title: 'Unable to go live',
        message,
        isSuccess: false,
      };
    default:
      return {
        title: 'Unable to go live',
        message,
        isSuccess: false,
      };
  }
}
